import { render } from "./PetDetail.vue?vue&type=template&id=880863a0&scoped=true"
import script from "./PetDetail.vue?vue&type=script&lang=js"
export * from "./PetDetail.vue?vue&type=script&lang=js"

import "./PetDetail.vue?vue&type=style&index=0&id=880863a0&scoped=true&lang=sass"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880863a0"]])

export default __exports__